// Official Genius Invokation TCG share IDs (the card numbers used by in-game deck codes), keyed like db.js.
// Generated from genshin-db 49a6544a and checked against real tournament deck codes.
const shareIds = {
    "chars": {
        "ganyu": 1,
        "diona": 2,
        "kaeya": 3,
        "chongyun": 4,
        "ayaka": 5,
        "eula": 6,
        "shenhe": 7,
        "qiqi": 8,
        "layla": 279,
        "charlotte": 334,
        "wrio": 363,
        "barbara": 9,
        "xingqiu": 10,
        "mona": 11,
        "tartaglia": 12,
        "kokomi": 13,
        "ayato": 14,
        "candace": 15,
        "nilou": 16,
        "yelan": 280,
        "neuvillette": 335,
        "furina": 364,
        "diluc": 17,
        "xiangling": 18,
        "bennett": 19,
        "amber": 20,
        "yoimiya": 21,
        "klee": 22,
        "hutao": 23,
        "yanfei": 24,
        "dehya": 25,
        "lyney": 281,
        "thoma": 319,
        "xinyan": 365,
        "fischl": 26,
        "razor": 27,
        "keqing": 28,
        "cyno": 29,
        "beidou": 30,
        "sara": 31,
        "raiden": 32,
        "yae": 33,
        "lisa": 34,
        "dori": 35,
        "kuki": 348,
        "sucrose": 36,
        "jean": 37,
        "venti": 38,
        "xiao": 39,
        "kazuha": 40,
        "wanderer": 41,
        "lynette": 282,
        "sayu": 320,
        "faruzan": 349,
        "ningguang": 42,
        "noelle": 43,
        "zhongli": 44,
        "albedo": 45,
        "itto": 46,
        "gorou": 283,
        "yunjin": 366,
        "collei": 47,
        "tighnari": 48,
        "nahida": 49,
        "yaoyao": 50,
        "baizhu": 51,
        "alhaitham": 284,
        "kirara": 336,
        "kaveh": 367,
        "cryocicinmage": 52,
        "signora": 277,
        "cryohypo": 321,
        "oceanid": 53,
        "mirrormaiden": 54,
        "abyssherald": 350,
        "narwhal": 368,
        "pyroagent": 55,
        "abysslector": 56,
        "eremitescorchingloremaster": 285,
        "crab": 351,
        "electrohypostasis": 57,
        "thundermanifestation": 286,
        "seahorse": 322,
        "ecicinmage": 337,
        "consecratedscorpion": 369,
        "maguu": 58,
        "dvalin": 287,
        "consecratedserpent": 370,
        "stonehidelawachurl": 59,
        "azhdaha": 278,
        "terrorshroom": 60,
        "apep": 371,
        "chevreuse": 395,
        "navia": 396,
        "frostoperative": 397,
        "freminet": 407,
        "xianyun": 408,
        "hydrohilichurlrogue": 409,
        "chiori": 420,
        "abysslectorvioletlightning": 421,
        "eremitefloralringdancer": 422,
        "rosaria": 432,
        "sigewinne": 433,
        "goldenwolflord": 434,
        "mualani": 444,
        "clorinde": 445,
        "arlecchino": 454,
        "kinich": 455,
        "kachina": 461,
        "emilie": 462,
        "sethos": 469,
        "xilonen": 470,
        "citlali": 477,
        "mavuika": 478,
        "chasca": 479,
        "lanyan": 492,
        "shikanoinheizou": 493,
        "gluttonousyumkasaurmountainking": 494,
        "iansan": 506,
        "yumemizukimizuki": 507,
        "lordoferodedprimalfire": 508,
        "varesa": 521,
        "ifa": 522,
        "hydrotulpa": 523,
        "escoffier": 533,
        "gaming": 534,
        "blackserpentknightrockbreakerax": 535,
        "skirk": 544,
        "ororon": 545,
        "consecratedhornedcrocodile": 546,
        "mika": 555,
        "ineffa": 556,
        "goldflamequcusaurtyrant": 557,
        "dahlia": 570,
        "aino": 571,
        "consecratedfangedbeast": 572,
        "flins": 584,
        "lauma": 585,
        "experimentalfieldgenerator": 586,
        "nefer": 596,
        "waywardhermeticspiritspeaker": 597,
        "blackserpentknightwindcutter": 598,
        "durin": 608,
        "jahoda": 609,
        "hydrohypostasis": 610,
        "columbina": 620,
        "illuga": 621,
    },
    "actions": {
        "undividedheart": 61,
        "shakennotpurred": 62,
        "coldbloodedstrike": 63,
        "steadybreathing": 64,
        "kantensenmyoublessing": 65,
        "wellspringofwarlust": 66,
        "mysticalabandon": 67,
        "riteofresurrection": 68,
        "lightsremit": 288,
        "asummationofinterest": 338,
        "terrorfortheevildoers": 372,
        "gloriousseason": 69,
        "thescentremained": 70,
        "prophecyofsubmersion": 71,
        "abyssalmayhemhydrosprout": 72,
        "tamakushicasket": 73,
        "kyoukafuushi": 74,
        "theoverflow": 75,
        "thestarryskiestheirflowersrain": 76,
        "turncontrol": 289,
        "heirtotheancientseasauthority": 339,
        "furinatalent": 373,
        "flowingflame": 77,
        "crossfire": 78,
        "grandexpectation": 79,
        "bunnytriggered": 80,
        "naganoharameteorswarm": 81,
        "poundingsurprise": 82,
        "sanguinerouge": 83,
        "rightoffinalinterpretation": 84,
        "stalwartandtrue": 85,
        "conclusiveovation": 290,
        "asubordinate'sskills": 323,
        "Rockin'inaFlamingWorld": 374,
        "stellarpredator": 86,
        "awakening": 87,
        "thunderingpenance": 88,
        "featherfalljudgment": 89,
        "lightningstorm": 90,
        "sinofpride": 91,
        "wishesunnumbered": 92,
        "theshrinessacredshade": 93,
        "pulsatingwitch": 94,
        "discretionarysupplement": 95,
        "towardweakness": 362,
        "chaoticentropy": 96,
        "landsofdandelion": 97,
        "embraceofwinds": 98,
        "conquerorofevilguardianyaksha": 99,
        "poeticsoffuubutsu": 100,
        "galesofreverie": 101,
        "acoldbladelikeashadow": 291,
        "skivingnewandimproved": 324,
        "wondrouspathoftruth": 352,
        "strategicreserve": 102,
        "igotyourback": 103,
        "dominanceofearth": 104,
        "descentofdivinity": 105,
        "aratakiichiban": 106,
        "rushinghound:swiftasthewind": 292,
        "decorousharmony": 375,
        "floralsidewinder": 107,
        "keensight": 108,
        "theseedofstoredknowledge": 109,
        "beneficent": 110,
        "allthingsareoftheearth": 111,
        "structuration": 293,
        "countlesssightstosee": 340,
        "theartofbudgeting": 376,
        "cicinscoldglare": 112,
        "painforpain": 294,
        "sternfrostprism": 325,
        "streamingsurge": 113,
        "mirrorcage": 114,
        "surgingundercurrent": 353,
        "lightlessfeeding": 377,
        "paidinfull": 115,
        "embersrekindled": 116,
        "scorpocalypse": 295,
        "moltenmail": 354,
        "absorbingprism": 117,
        "grievingecho": 296,
        "pearlsolidification": 326,
        "electrocicinsgleam": 341,
        "fatalfulmination": 378,
        "transcendentautomaton": 118,
        "rendingvortex": 297,
        "deathlycyclone": 379,
        "stonehidereforged": 119,
        "lunarcyclesunending": 298,
        "proliferatingspores": 120,
        "athousandyoung": 380,
        "magicguide": 121,
        "sacrificialfragments": 122,
        "skywardatlas": 123,
        "athousandfloatingdreams": 124,
        "fruitoffulfillment": 125,
        "lostprayertothesacredwinds": 299,
        "tulaytullahsremembrance": 300,
        "tomeoftheeternalflow": 342,
        "cashflowsupervision": 381,
        "ravenbow": 126,
        "sacrificialbow": 127,
        "skywardharp": 128,
        "amosbow": 129,
        "elegyfortheend": 130,
        "kingssquire": 131,
        "eotl": 382,
        "whiteirongreatsword": 132,
        "sacrificialgreatsword": 133,
        "wolfsgravestone": 134,
        "skywardpride": 135,
        "thebell": 136,
        "beaconofthereedsea": 301,
        "forestregalia": 383,
        "whitetassel": 137,
        "lithicspear": 138,
        "skywardspine": 139,
        "vortexvanquisher": 140,
        "engulfinglightning": 141,
        "moonpiercer": 142,
        "primordialjadewinged-spear": 302,
        "rightfulreward": 355,
        "travelershandysword": 143,
        "sacrificialsword": 144,
        "aquilafavonia": 145,
        "skywardblade": 146,
        "favoniussword": 147,
        "lightoffoliarincision": 303,
        "sapwoodblade": 327,
        "splendor": 384,
        "adventurersbandana": 148,
        "luckydogssilvercirclet": 149,
        "travelingdoctorshandkerchief": 150,
        "gamblersearrings": 151,
        "instructorscap": 152,
        "exilescirclet": 153,
        "ornatekabuto": 154,
        "emblemofseveredfate": 155,
        "generalsancienthelm": 156,
        "tenacityofthemillelith": 157,
        "thunderingpoise": 158,
        "vermillionhereafter": 159,
        "capriciousvisage": 160,
        "shimenawasreminiscence": 161,
        "crownofwatatsumi": 162,
        "oceanhuedclam": 163,
        "shadowofthesandking": 164,
        "gildeddreams": 304,
        "flowingrings": 305,
        "echoesofanoffering": 306,
        "heartofkhvarenasbrilliance": 307,
        "vourukashasglow": 308,
        "veteransvisage": 328,
        "goldentroupesreward": 343,
        "amethystcrown": 356,
        "marechausseehunter": 385,
        "goldentroupe": 386,
        "flop": 387,
        "brokenrimesecho": 165,
        "blizzardstrayer": 166,
        "winestainedtricorne": 167,
        "heartofdepth": 168,
        "witchsscorchinghat": 169,
        "crimsonwitchofflames": 170,
        "thundersummonerscrown": 171,
        "thunderingfury": 172,
        "viridescentvenerersdiadem": 173,
        "viridescentvenerer": 174,
        "maskofsolitudebasalt": 175,
        "archaicpetra": 176,
        "laurelcoronet": 177,
        "deepwoodmemories": 178,
        "liyueharborwharf": 179,
        "knightsoffavoniuslibrary": 180,
        "jadechamber": 181,
        "dawnwinery": 182,
        "wangshuinn": 183,
        "favoniuscathedral": 184,
        "tenshukaku": 185,
        "grandnarukamishrine": 186,
        "sangonomiyashrine": 187,
        "sumerucity": 188,
        "vanarana": 189,
        "chinjuforest": 190,
        "goldenhouse": 191,
        "gandharvaville": 192,
        "stormterrorslair": 193,
        "weepingwillowofthelake": 309,
        "operaepiclese": 310,
        "fortressofmeropide": 344,
        "seiraiisland": 357,
        "mausoleum": 388,
        "centrallaboratoryruins": 389,
        "paimon": 194,
        "katheryne": 195,
        "timaeus": 196,
        "wagner": 197,
        "chefmao": 198,
        "tubby": 199,
        "timmie": 200,
        "liben": 201,
        "changtheninth": 202,
        "ellin": 203,
        "irontonguetian": 204,
        "liusu": 205,
        "hanachirusato": 206,
        "kidkujirai": 207,
        "xudong": 208,
        "dunyarzad": 209,
        "rana": 210,
        "masterzhang": 211,
        "setaria": 212,
        "yayoinanatsuki": 213,
        "mamere": 311,
        "jeht": 329,
        "silverandmelus": 330,
        "taroumaru": 358,
        "tingsfavoritecard": 359,
        "sirarthur": 390,
        "parametrictransformer": 214,
        "nre": 215,
        "redfeatherfan": 216,
        "treasureseekingseelie": 217,
        "seeddispensary": 312,
        "mementolens": 313,
        "lumenstoneadjuvent": 345,
        "kusava": 391,
        "ancientcourtyardMAX1": 218,
        "covenantofrockMAX1": 219,
        "joyouscelebrationMAX1": 220,
        "freshwindoffreedomMAX1": 221,
        "ineveryhouseastoveMAX1": 222,
        "passingofjudgmentMAX1": 314,
        "dayofresistancemomentofshattereddreamsMAX1": 346,
        "viciousancientbattleMAX1": 392,
        "elementalresonancewovenice": 223,
        "elementalresonanceshatteringice": 224,
        "elementalresonancewovenwaters": 225,
        "elementalresonancesoothingwater": 226,
        "elementalresonancewovenflames": 227,
        "elementalresonanceferventflames": 228,
        "elementalresonancewoventhunder": 229,
        "elementalresonancehighvoltage": 230,
        "elementalresonancewovenwinds": 231,
        "elementalresonanceimpetuouswinds": 232,
        "elementalresonancewovenstone": 233,
        "elementalresonanceenduringrock": 234,
        "elementalresonancewovenweeds": 235,
        "elementalresonancesprawlinggreenery": 236,
        "windandfreedom": 237,
        "stoneandcontracts": 238,
        "thunderandeternity": 239,
        "natureandwisdom": 240,
        "waterandjustice": 393,
        "thebestesttravelcompanion": 241,
        "changingshifts": 242,
        "tossup": 243,
        "strategize": 244,
        "ihaventlostyet": 245,
        "leaveittome": 246,
        "whenthecranereturned": 247,
        "starsigns": 248,
        "calxsarts": 249,
        "masterofweaponry": 250,
        "blessingofthedivinerelicsinstallation": 251,
        "quickknit": 252,
        "sendoff": 253,
        "guardiansoath": 254,
        "abyssalsummons": 255,
        "fatuiconspiracy": 256,
        "plungingstrike": 257,
        "heavystrike": 258,
        "thelegendofvennessa": 259,
        "friendshipeternal": 260,
        "rhythmofthegreatdream": 261,
        "whereistheunseenrazor": 262,
        "pankration": 263,
        "lyresong": 264,
        "theboarprincess": 315,
        "fallsandfortune": 316,
        "flickeringfour-leafsigil": 317,
        "machineassemblyline": 331,
        "sunyataflower": 332,
        "controlleddirectionalblast": 347,
        "underwatertreasurehunt": 360,
        "countdown": 394,
        "jueyunguoba": 265,
        "adeptustemptation": 266,
        "lotusflowercrisp": 267,
        "northernsmokedchicken": 268,
        "sweetmadame": 269,
        "mondstadthashbrown": 270,
        "mushroompizza": 271,
        "mintymeatrolls": 272,
        "teyvatfriedegg": 273,
        "sashimiplatter": 274,
        "tandooriroastchicken": 275,
        "buttercrab": 276,
        "fishandchips": 318,
        "matsutakemeatrolls": 333,
        "macarons": 361,
        "vanguardscoordinatedtactics": 398,
        "undiscloseddistributionchannels": 399,
        "rimeflowrapier": 400,
        "ultimateoverlordsmegamagicsword": 401,
        "prospectorsdrill": 402,
        "gladiatorstriumphus": 403,
        "serene": 404,
        "idratherlosemoneymyself": 405,
        "tada": 406,
        "momentofwakingandresolve": 410,
        "theycallhercloudretainer": 411,
        "featherweightfoam": 412,
        "xenochromatichuntersray": 413,
        "yumkasaurus": 414,
        "koholasaurus": 415,
        "stadiumofthesacredflame": 416,
        "atea": 417,
        "sauriandiningbuddies": 418,
        "edictofabsolutionMAX1": 419,
        "infivecolorsdyed": 423,
        "chainlightningcascade": 424,
        "spiritserpentsswirl": 425,
        "portablepowersaw": 426,
        "conductorstophat": 427,
        "tepetlisaurus": 428,
        "stagetepetl": 429,
        "eremiteteatime": 430,
        "sauruscrackers": 431,
        "divineretribution": 435,
        "requiresappropriaterest": 436,
        "beastlycorrosion": 437,
        "flowingpurity": 438,
        "maidensfadingbeauty": 439,
        "iktomisaurus": 440,
        "scionsofthecanopy": 441,
        "ultimatesurfingbuddy": 442,
        "glitteringgemstones": 443,
        "nightrealmsgiftcrestsandtroughs": 446,
        "darkshatteringflame": 447,
        "demonwarriorsfeathermask": 448,
        "qucusaurus": 449,
        "peopleofthesprings": 450,
        "pilgrimageofthereturnofthesacredflameMAX1": 451,
        "abundantphlogiston": 452,
        "puffpops": 453,
        "allreprisalsandarrearsminetobear": 456,
        "nightrealmsgiftrepaidinfull": 457,
        "flowerfeatherclan": 458,
        "littletepetlisaurtreasurehunteratlarge": 459,
        "hotspringoclock": 460,
        "nightrealmsgiftheartofunity": 463,
        "marcottesillage": 464,
        "waverider": 465,
        "mastersofthenightwind": 466,
        "inthenameoftheextreme": 467,
        "mystiquesoup": 468,
        "pylonofthesojourningsuntemple": 471,
        "touroftepeilhuitl": 472,
        "tatankasaurus": 473,
        "collectiveofplenty": 474,
        "artofsleepymeditation": 475,
        "singyourheartout": 476,
        "mamaloacosfrigidrain": 480,
        "humanitysnameunfettered": 481,
        "bullettrick": 482,
        "thedockhandsassistant": 483,
        "crownofthesaints": 484,
        "scrolloftheheroofcindercity": 485,
        "rawrrawr": 486,
        "fightfordeathMAX1": 487,
        "flyingsquadattack": 488,
        "fireandwar": 489,
        "fruitsoftraining": 490,
        "harvestsboon": 491,
        "dancevestmentsbillowlikerainbowjade": 495,
        "curiouscasefiles": 496,
        "thealldevourer": 497,
        "crownlesscrown": 498,
        "whimsicaldanceofthewithered": 499,
        "calligraphytavern": 500,
        "constellationmetropole": 501,
        "forestblessing": 502,
        "giftofthegoddessofprophecy": 503,
        "harvesttime": 504,
        "awesomebro": 505,
        "teachingsofthecollectiveofplenty": 509,
        "yourechoimeetindreams": 510,
        "undyingfury": 511,
        "royalmasque": 512,
        "unfinishedreverie": 513,
        "fragmentofharmonicwhimsy": 514,
        "felldragonsawakening": 515,
        "narrationfootnotes": 516,
        "brokensea": 517,
        "ablessingfromm": 518,
        "revelrousbeats": 519,
        "aquasimulacra": 520,
        "aheroofjusticestriumph": 524,
        "tacticalwarmcompressbandaging": 525,
        "flowconvergence": 526,
        "everlastingmoonglow": 527,
        "felldragonsmonocle": 528,
        "noblesseoblige": 529,
        "adventurersguild": 530,
        "anancientsacrificeofsacredbrocade": 531,
        "chenyubrew": 532,
        "teapartiesburstingwithcolor": 536,
        "bringerofblessing": 537,
        "oncestoodagainstthetideofdarkwaterslikebedrock": 538,
        "nymphsdream": 539,
        "seymour": 540,
        "lostlegaciesinthesandMAX1": 541,
        "thenarzissenkreuzadventure": 542,
        "plantosavetheworld": 543,
        "fartofall": 547,
        "trailsamidsttheforestfog": 548,
        "deathlyoverflow": 549,
        "starcallerswatch": 550,
        "flameforgedinsight": 551,
        "dyedtassel": 552,
        "bonaandcocouik": 553,
        "anadventurethroughthemorningmist": 554,
        "companionscounsel": 558,
        "rectifyingprocessor": 559,
        "flamelordsblessing": 560,
        "silvermoonhall": 561,
        "tidesealstone": 562,
        "frostmoonenclave": 563,
        "nashatown": 564,
        "kuuvahkiexperimentaldesignbureau": 565,
        "elementaltransfigurationsuperconductblessing": 566,
        "elementaltransfigurationvaporizeblessing": 567,
        "geniussupgradetechnique": 568,
        "clinkclanklegion": 569,
        "youshallgooutwithjoy": 573,
        "theburdenofcreativegenius": 574,
        "witheredreedseclipsethesun": 575,
        "snarehook": 576,
        "blubberbeast": 577,
        "lepinepauline": 578,
        "elementaltransfigurationbloomblessing": 579,
        "elementaltransfigurationlavablessing": 580,
        "moonsignascendantgleam": 581,
        "moonandhomeland": 582,
        "cleaningtime": 583,
        "parttheveilofsnow": 587,
        "olipsweavemesongsandpsalms": 588,
        "gravityfield": 589,
        "gladiatorsfinale": 590,
        "netochka": 591,
        "elementaltransfigurationrimegrassblessing": 592,
        "elementaltransfigurationstormgaleblessing": 593,
        "theothersideofthefrostmoonMAX1": 594,
        "roulettespecial": 595,
        "victoryflowsfromtheturningoftides": 599,
        "flowofforms": 600,
        "oncethelonewindthatkeptthedarkcalamityatbay": 601,
        "nightmareomen": 602,
        "elementaltransfigurationaquabreezeblessing": 603,
        "elementaltransfigurationthunderbloomblessing": 604,
        "lilfungisfuntasticfiesta": 605,
        "thepowerofresearch": 606,
        "lakkaberrypie": 607,
        "adamahsredemption": 611,
        "backstreetguile": 612,
        "treacheroustorrent": 613,
        "genesisofstarsigns": 614,
        "sparkbornemagic": 615,
        "phantasmalnocturne": 616,
        "temporalwindseulogy": 617,
        "witchshomework": 618,
        "feastinginasharedtoast": 619,
        "radianceoverblossomsandpeaks": 622,
        "surgeoflightning": 623,
        "sevenfoldtransmutation": 624,
        "bookofblindinglight": 625,
        "elkwithfangedantlers": 626,
        "recollectionofdayspast": 627,
        "elementaltransfigurationoverloadblessing": 628,
        "returnofthethreemoonsMAX1": 629,
    },
}

export default shareIds
